import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { HRM2010_R01DetailDto, HRM2010_R01Dto, HRM2010_R01HeaderDto } from './Dto_HRM2010_R01';
import { HRM2010_R01Filter } from './Store_HRM2010_R01';

/** 일일근태 화면 API의 기본 경로이다. */
const BASE_URL = `${config.apiUrl}/HRM2010_R01`;

/** 일일근태 목록을 조회한다. */
export const getHRM2010_R01List = async (option: 'search' | 'refetch', params: Partial<HRM2010_R01Filter>) =>
    getData<ResponseDto<HRM2010_R01HeaderDto[]>>(`${BASE_URL}/header/${option}`, { params });

/** 사원·근무일자의 외출·복귀 기록을 조회한다. */
export const getHRM2010_R01DetailList = async (empNo: string, workDt: string) =>
    getData<ResponseDto<HRM2010_R01DetailDto[]>>(
        `${BASE_URL}/detail/${encodeURIComponent(empNo)}/${encodeURIComponent(workDt)}`,
    );

/** 변경된 일일근태와 외출 기록을 저장한다. */
export const patchHRM2010_R01 = async (data: HRM2010_R01Dto) =>
    patchData<HRM2010_R01Dto, ResponseDto<number>>(BASE_URL, data);

/** 근태가 없는 재직자에게 정상출근을 만든다. */
export const postHRM2010_R01Bulk = async (data: HRM2010_R01Dto) =>
    postData<HRM2010_R01Dto, ResponseDto<HRM2010_R01Dto>>(`${BASE_URL}/bulk`, data);

/** 일일근태 행 하나의 시간을 서버에서 미리 계산한다. */
export const postHRM2010_R01Calculation = async (data: HRM2010_R01Dto) =>
    postData<HRM2010_R01Dto, ResponseDto<HRM2010_R01HeaderDto>>(`${BASE_URL}/calculate`, data);

/** 조회 조건과 같은 일일근태 XLSX를 받는다. */
export const downloadExcel_HRM2010_R01 = async (option: 'search', params: Partial<HRM2010_R01Filter>) =>
    getData<ResponseDto<string>>(`${BASE_URL}/excel/${option}`, { params });
